import { TemplateData } from 'src/app/data/configurator/template/template.data';

declare const fabric: any;

export class Template {

  private _data: TemplateData;
  private _finalMasker:any; // Forme de l'étiquette moins éventuelles zone imprimée sur planche vendue
  private _shape: any; // etiquette complete
  private _shapeMask: any; // etiquette complete (inverted)
  private _printedArea: any; // etiquette complete (inverted)
  private _folds: any;
  private _border: any;
  private _shapeForPrint: any;

  /**
   * Contructor
   */
  constructor(data: TemplateData) {
    // console.log("Template.constructor()");


    this._data = data;

    fabric.loadSVGFromString(this._data.svg, (objects, options) => {


      // console.log("Template.constructor() SVG loaded");

      this._border = fabric.util.object.clone(objects[0]);
      this._border.set({
        evented: false,
        fill: 'transparent',
        strokeWidth: 1,
        stroke: '#878787'
      });

      this._shapeForPrint = fabric.util.object.clone(objects[0]);

      let _printableAreaMasker = fabric.util.object.clone(objects[1]);
      _printableAreaMasker.set({
        evented: false,
        left:(objects[0].width/-2)+ objects[1].left,
        top:(objects[0].height/-2)+ objects[1].top
      });
      _printableAreaMasker.inverted = true;

      this._printedArea = fabric.util.object.clone(objects[0]);
      this._printedArea.set({
          fill: 'red',
          opacity:.3,
          clipPath:_printableAreaMasker,
          evented: false,
      });


      this._shape = objects[0];
      this._shape.set({
        evented: false,
        fill: 'yellow'
      });

      let _tplMask = fabric.util.object.clone(objects[0]);

      this._finalMasker = new fabric.Group([objects[1]],{
        evented: false,
      });
      this._finalMasker.inverted = true;

      this._shapeMask = new fabric.Group([_tplMask]);
      // this._masker = new fabric.Group([objects[1]]);
      _tplMask.set({
        fill: 'red',
        strokeWidth: 0
      });
      this._shapeMask.set({
        evented: false,
      });
      this._shapeMask.inverted = true;

      // console.log(this._masker, this._shape);
    });
  }




  /**
   * Masker
   */
  get shapeMasker(): any {
    return this._shapeMask;
  }

  /**
   * PrintedArea
   */
  get printedArea(): any {
    return this._printedArea;
  }

  /**
   * Shape
   */
  get shape(): any {
    return this._shape;
  }

  /**
   * Border
   */
  get border(): any {
    return this._border;
  }

  /**
   * Border
   */
  get shapeForPrint(): any {
    return this._shapeForPrint;
  }

  /**
   * Folds
   */
  get folds(): any {
    return this._folds;
  }

  /**
   * Cleanup
   */
  public cleanup(): void {

  }
}
